import { IssueAndServiceSharedValues } from '../constants/IssueAndServiceKeys';

export const processFromDBForAutoComplete = (object, keys, dropdownTable) => {
  const objectCopy = JSON.parse(JSON.stringify(object));

  Object.keys(objectCopy).forEach((key) => {
    if (keys[key] && object[key]) {
      objectCopy[keys[key]] = object[key];
      delete objectCopy[key];
    }
  });

  if (objectCopy[IssueAndServiceSharedValues.teamMembers]) {
    objectCopy[IssueAndServiceSharedValues.teamMembers] = dropdownTable['lead'].find((member) => {
      return member._id === objectCopy[IssueAndServiceSharedValues.teamMembers];
    });
  }

  return objectCopy;
};

export const processCellsForAutoComplete = (object, dropdownTable, id) => {
  const objectCopy = JSON.parse(JSON.stringify(object));
  if (objectCopy[IssueAndServiceSharedValues.teamMembers]) {
    const objCopyTeamMemberIdSet = new Set(
      objectCopy[IssueAndServiceSharedValues.teamMembers]
        .filter((member) => member)
        .map((member) => (member._id ? member._id : member))
    );
    objectCopy[IssueAndServiceSharedValues.teamMembers] = dropdownTable['lead'].filter((member) =>
      objCopyTeamMemberIdSet.has(member._id)
    );
  }
  objectCopy._id = id;
  return objectCopy;
};
